import { render, staticRenderFns } from "./StudentLeaveSubRecordDetail.vue?vue&type=template&id=04c477f2&scoped=true&"
import script from "./StudentLeaveSubRecordDetail.vue?vue&type=script&lang=js&"
export * from "./StudentLeaveSubRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudentLeaveSubRecordDetail.vue?vue&type=style&index=0&id=04c477f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c477f2",
  null
  
)

export default component.exports